var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisibility24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.583008 7C1.59217 4.43917 4.08301 2.625 6.99967 2.625C9.91634 2.625 12.4072 4.43917 13.4163 7C12.4072 9.56083 9.91634 11.375 6.99967 11.375C4.08301 11.375 1.59217 9.56083 0.583008 7ZM12.1447 7C11.1822 5.03417 9.21051 3.79167 6.99967 3.79167C4.78884 3.79167 2.81717 5.03417 1.85467 7C2.81717 8.96583 4.78884 10.2083 6.99967 10.2083C9.21051 10.2083 11.1822 8.96583 12.1447 7ZM6.99967 5.54167C7.80467 5.54167 8.45801 6.195 8.45801 7C8.45801 7.805 7.80467 8.45833 6.99967 8.45833C6.19467 8.45833 5.54134 7.805 5.54134 7C5.54134 6.195 6.19467 5.54167 6.99967 5.54167ZM4.37467 7C4.37467 5.55333 5.55301 4.375 6.99967 4.375C8.44634 4.375 9.62467 5.55333 9.62467 7C9.62467 8.44667 8.44634 9.625 6.99967 9.625C5.55301 9.625 4.37467 8.44667 4.37467 7Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibility24Px);
export default __webpack_public_path__ + "static/media/visibility_24px.7f88ccba3c2a397e4ccb0c5adcc8f8e6.svg";
export { ForwardRef as ReactComponent };